/**
 * Собирает данные разных текущих stores в единый контракт карточек каталога.
 * Не загружает данные и не управляет состоянием интерфейса.
 */
import { formatRussianCount } from "@/utils/pluralizationUtils";

const INTEGRATION_KEYS = [
  "trackers",
  "saby",
  "chats",
  "rn-card",
];

const DEFINITIONS = {
  trackers: {
    routeName: "IntegrationTrackers",
    icon: "🛰️",
    category: "ТЕЛЕМЕТРИЯ",
    title: "Трекеры",
    description: "Местоположение транспорта и фактический пробег",
  },
  saby: {
    routeName: "IntegrationSaby",
    icon: "📄",
    category: "ДОКУМЕНТЫ",
    title: "Saby (ЭДО)",
    description: "Оформление обязательных электронных перевозочных документов",
  },
  chats: {
    routeName: "IntegrationChats",
    icon: "💬",
    category: "СВЯЗЬ",
    title: "Чаты",
    description: "Переписка с клиентами через MAX в одном месте",
  },
  "rn-card": {
    available: false,
    routeName: "IntegrationRnCard",
    icon: "⛽",
    category: "ТОПЛИВО",
    title: "РН-Карт",
    description: "Автоматический учёт заправок в расходах транспорта",
  },
};

const enabledItems = (items) => items.filter((item) => item.enabled);

const findEnabledIntegration = (integrations, providerType) =>
  integrations.find(
    (integration) =>
      integration.provider_type === providerType && integration.enabled
  );

/** Возвращает карточки в продуктовом порядке с агрегированным состоянием. */
export function buildIntegrationCatalogCards({
  integrations = [],
  trackers = [],
  chatProviders = [],
} = {}) {
  const activeTrackers = enabledItems(trackers);
  const saby = findEnabledIntegration(integrations, "Integration::Saby");
  const maxBots = enabledItems(
    chatProviders.filter((provider) => provider.provider_type === "max_bot")
  );

  const state = {
    trackers: {
      connected: activeTrackers.length > 0,
      fact: formatRussianCount(trackers.length, {
        one: "трекер",
        few: "трекера",
        many: "трекеров",
      }),
    },
    saby: {
      connected: Boolean(saby),
      fact: saby?.org_name || "",
    },
    chats: {
      connected: maxBots.length > 0,
      fact: formatRussianCount(maxBots.length, {
        one: "бот",
        few: "бота",
        many: "ботов",
      }),
    },
    "rn-card": {
      connected: false,
      fact: "",
    },
  };

  return INTEGRATION_KEYS.map((key) => {
    const connected = state[key].connected;
    return {
      key,
      ...DEFINITIONS[key],
      connected,
      available: DEFINITIONS[key].available !== false,
      fact: DEFINITIONS[key].available === false
        ? "Узнать больше"
        : connected
          ? state[key].fact
          : "Подключить",
      route: { name: DEFINITIONS[key].routeName },
    };
  });
}
